import './App.css';
import './language/i18n.js';
import {Router} from "./Router";
import GlobalStyle from './style/GlobalStyle';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import zhCN from 'antd/lib/locale/zh_CN';
import { useSelector } from 'react-redux';
import { currentLanguage } from './features/language/languageSlice';
import { useLayoutEffect } from 'react';
import moment from 'moment';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query'

// moment_locale
import moment_locale from './moment_locale';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})
// user element
function App() {
  const locale = useSelector(currentLanguage);
  useLayoutEffect(() => {
    moment.locale('zh-CN', moment_locale);
    moment.locale(locale === 'en' ? 'en' : 'zh-CN');
  }, [locale]);
  return (
    <ConfigProvider locale={locale === 'zh' ? zhCN : enUS}>
      <QueryClientProvider client={queryClient}>
        <GlobalStyle />
        <Router />
      </QueryClientProvider>
    </ConfigProvider>
  );
}

export default App;
